import Button from '@/components/Buttons/Button';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import stars from '@/images/agents/stars.svg';
import styled from '@emotion/styled';
import { MouseEventHandler } from 'react';

const StyledHoverButton = styled(Button)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30px;
    height: 30px;
    padding: 0;
    margin: 8px;
    min-width: 30px;
    background: ${({ theme }) => theme.colors.primary.main};
    overflow: hidden;
    justify-content: flex-start;
    font-size: 1rem;
    flex-wrap: nowrap;
    white-space: nowrap;
    flex-direction: row;
    padding-left: 7px;
    gap: 8px;
    transition: width 0.3s ease-in-out;
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

    :hover {
        width: 150px;
        background: ${({ theme }) => theme.colors.primary.main};
    }
`;

const StyledCustomTooltip = styled(CustomTooltip)`
    width: fit-content;
    z-index: 6;
`;

interface Props {
    onClick: MouseEventHandler<HTMLButtonElement>;
    disabled: boolean;
}

export function UpgradeV2Button({ onClick, disabled }: Props) {
    return (
        <StyledCustomTooltip
            containerWidth="fit-content"
            placement="top"
            whitespace="normal"
            title="Cannot migrate to Agent 2.0 – compatible Avatar not found."
            disableHoverListener={!disabled}
            onClick={e => disabled && e.stopPropagation()}>
            <StyledHoverButton onClick={onClick} variant="text" color="secondary" disabled={disabled}>
                <MaskedIcon src={stars} size="16px" color="black" />
                Upgrade to Agent 2.0
            </StyledHoverButton>
        </StyledCustomTooltip>
    );
}
